import Head from "next/head";
import React from "react";

export default function CustomMeta({type, section, dateModified, datePublished, author}) {
  if (!type) return null;

  const prefix = type === "article" ? "article" : null;
  if (!prefix) return null;

  return (
    <Head>
      {section ? <meta property={`${prefix}:section`} content={section}/> : null}
      {dateModified ? <meta property={`${prefix}:modified_time`} content={dateModified}/> : null}
      {datePublished ? <meta property={`${prefix}:published_time`} content={datePublished}/> : null}
      {author ? <meta property={`${prefix}:author`} content={author}/> : null}
    </Head>
  );
}
